module.exports = __webpack_public_path__ + "img/government-affairs-icon.ff31ab2d.png";